import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const provinceURL = `api/v1/location-app/province`;

//obtaining the paginated data
export const getProvince = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${provinceURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllProvince = () => axiosInstance.get(`${provinceURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageProvince = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${provinceURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getProvinceById = (id) => axiosInstance.get(`${provinceURL}/retrieve/${id}`);

//creating function
export const createProvince = (body) => axiosInstance.post(`${provinceURL}/create`, body);
//updating function
export const updateProvince = (id, body) => axiosInstance.patch(`${provinceURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${provinceURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataProvinceName = (e, cancelToken) =>
  axiosInstance.get(`${provinceURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
